export default __webpack_public_path__ + "static/media/lk.445a51fb.svg";